<template>
  <div class="footer">
    	<p>Copyright © 2017 HannaLiu.</p>
  </div>
</template>

<script>
export default {
  name: 'footer'
}
</script>

<style scoped>
.footer{text-align: center;font-size: 12px;color: #FFFFFF;background: url(../assets/img/footer-bg.jpg) no-repeat;height: 50px;position: fixed;bottom: 0;left: 0;width: 100%;}
.footer p{line-height: 50px; margin: 0;}
</style>



// WEBPACK FOOTER //
// footer.vue?e28b3ef2